import { getOptionsTableKey } from './http/trading-ws/options';
import type { DefaultError, QueryObserverOptions, QueryClient } from '@tanstack/query-core';
import { queryOptions } from '@tanstack/react-query';
import type { FetchableTableCreationResult } from 'src/types';

// Constants
const OPTIONS = 'options';
const OPTIONS_LIST = 'options-list';

export const getOptionsTableKeyQuery = () =>
    queryOptions<FetchableTableCreationResult | null>({
        queryKey: [OPTIONS, 'table-key'],
        queryFn: () => getOptionsTableKey(),
    });

/**
 * Creates a query for fetching options list entries with a prefix
 */
export const getOptionsListEntriesQuery = (
    search: string,
    service: { fetchOptionsListEntries: (search: string) => Promise<string[]> },
): QueryObserverOptions<string[], DefaultError> => ({
    queryKey: [OPTIONS_LIST, search],
    queryFn: () => service.fetchOptionsListEntries(search),
});

// Invalidation
export const invalidateOptionsTableKeyQuery = (queryClient: QueryClient) => {
    return queryClient.invalidateQueries({ queryKey: [OPTIONS, 'table-key'] });
};

export const invalidateOptionsListQueries = (queryClient: QueryClient) => {
    return queryClient.invalidateQueries({ queryKey: [OPTIONS_LIST] });
};
